import { Record } from '../transit';

// Record is like class, but immutable and with default values.
// https://facebook.github.io/immutable-js/docs/#/Record
const User = Record({
  authenticatedAt: null,
  displayName: '',
  email: '',
  id: '',
  profileImageURL: '',
  provider: ''
}, 'user');

export default User;



// WEBPACK FOOTER //
// ./src/common/users/user.js